/**
 * 숫자를 간단한 한글 금액으로 변환 (만, 억 단위만)
 * @param num 변환할 숫자
 * @returns 간단한 한글 금액 문자열
 */
export function numberToSimpleKoreanCurrency(num: number): string {
  // 소숫점 무시하고 정수로 변환
  num = Math.floor(num);

  if (num === 0) return '영원';
  if (num < 0) return `마이너스 ${numberToSimpleKoreanCurrency(Math.abs(num))}`;

  // 1억 이상인 경우
  if (num >= 100000000) {
    const billion = Math.floor(num / 100000000);
    const million = Math.floor((num % 100000000) / 10000);
    const remainder = num % 10000;

    let result = `${billion}억`;

    if (million > 0) {
      result += ` ${million}만`;
    }

    if (remainder > 0) {
      result += ` ${remainder}`;
    }

    return result + '원';
  }

  // 1만 이상 1억 미만인 경우
  if (num >= 10000) {
    const million = Math.floor(num / 10000);
    const remainder = num % 10000;

    let result = `${million}만`;

    if (remainder > 0) {
      result += ` ${remainder}`;
    }

    return result + '원';
  }

  // 1만 미만인 경우
  return `${num}원`;
}
